import { useModal } from '../../contexts/ModalContext'
import FormularioRD from '../../rdstation/formularioRD'
import Container from '../container'

export default function BannerSeguranca() {
  const { openModal } = useModal()
  return (
    <section className="text-white min-h-[542px] flex items-end md:block pt-20 pb-[68px] md:pb-14 lg:bg-center bg-[url(../assets/inovation-banner-mobile.png)] md:bg-[url(../assets/inovation-banner.png)] bg-cover">
      <Container>
        <div className="md:max-w-[628px] ms-auto space-y-12">
          <div className="space-y-2 text-center md:text-left">
            <strong className="font-inter-bold text-[20px] md:text-[32px] block">
              “Segurança, tecnologia e <br /> performance evoluem juntas”
            </strong>
            <p className="md:text-[28px] block">
              Desenhamos <strong className="font-inter-bold">soluções</strong>{' '}
              para garantir o uso{' '}
              <strong className="font-inter-bold">seguro da tecnologia</strong>,
              protegendo seus dados, operando com as{' '}
              <strong className="font-inter-bold">mais altas normas</strong> de
              compliance.
            </p>
          </div>
          <button
            type="button"
            onClick={() => openModal(<FormularioRD />)}
            className="text-lg md:text-2xl mx-auto md:mx-0 block bg-white rounded-full text-[rgba(252,0,33,1)] py-2 px-7 w-fit font-inter-medium hover:scale-105 transition-all duration-300 cursor-pointer"
          >
            Otimize o seu negócio!
          </button>
        </div>
      </Container>
    </section>
  )
}
